interface QuestionsAllProps {
  isMinorMobile: boolean;
  allQuestion: number;
  questionNow: number;
}
export const QuestionsAll = ({
  isMinorMobile,
  questionNow,
  allQuestion,
}: QuestionsAllProps) => {
  return (
    <p
      className={`text-color-02 font-bold text-body-02 ${
        isMinorMobile ? "m-3" : ""
      }`}
    >
      {questionNow} de {allQuestion} preguntas respondidas
    </p>
  );
};
